<article id="base_wrap" class="outlet-body">
  <nikkan-corporate-header />
  <div>
    <div class="content">
      <router-outlet></router-outlet>
    </div>
    <nikkan-corporate-footer />
  </div>
</article>
<nikkan-corporate-scroll-top />
